import { createFileRoute } from '@tanstack/react-router'
import ColecaoDetailPage from '@/pages/colecoes/colecao-detail'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/colecoes/$colecaoId/',
)({
  component: function ColecaoDetailRoute() {
    const { dashboardId, colecaoId } = Route.useParams()
    return (
      <RequireModule module={MODULES.CAMPANHAS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.VIEW_IMOB_DATA}>
          <ColecaoDetailPage colecaoId={colecaoId} dashboardId={dashboardId} />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
